<span class="hx-focus-indicator"></span>
@if (loading()) {
  <span aria-hidden="true" class="hx-button-spinner"></span>
}
@if (startItem()) {
  <hx-icon [svgIcon]="startItem()!" inline="true" />
}
<ng-content />
@if (endItem()) {
  <hx-icon [svgIcon]="endItem()!" inline="true" />
}
